"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var lodash_1 = require("lodash");
var icons_1 = __importDefault(require("../../../assets/icons"));
var theme_1 = __importDefault(require("../../../styles/theme"));
var Icon_1 = require("../../atoms/Icon/Icon");
var TabScrollButton_1 = require("../../atoms/TabScrollButton/TabScrollButton");
var TabSwitch_style_1 = __importDefault(require("./TabSwitch.style"));
/**
 * TabSwitch molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-tabswitch--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/TabSwitch Source}
 */
var TabSwitch = function (_a) {
    var tabs = _a.tabs, onChange = _a.onChange, value = _a.value, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? theme_1.default.colors.globalBackgroundLight : _b, buttonComponent = _a.buttonComponent, className = _a.className;
    var classes = (0, TabSwitch_style_1.default)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(core_1.Tabs, __assign({ value: value === -1 ? 0 : value, onChange: function (_event, newValue) { return onChange(newValue); }, indicatorColor: 'primary', textColor: 'primary', variant: 'scrollable', scrollButtons: 'on', classes: { root: classes.tabBar, indicator: classes.indicator }, ScrollButtonComponent: buttonComponent || TabScrollButton_1.TabScrollButton, TabScrollButtonProps: { color: backgroundColor } }, { children: renderTabs() })) })));
    function renderTabs() {
        return (0, lodash_1.map)(tabs, function (_a, index) {
            var title = _a.title, info = _a.info, disabled = _a.disabled, hasError = _a.hasError;
            return ((0, jsx_runtime_1.jsx)(core_1.Tab, { label: info ? "".concat(title, " (").concat(info, ")") : title, icon: hasError ? (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconPath: icons_1.default.error, color: theme_1.default.colors.error, size: 20 }) : undefined, "aria-controls": title, classes: { root: classes.tab, selected: classes.tabSelected, wrapper: classes.wrapper }, disableRipple: true, disabled: disabled }, title + index.toString()));
        });
    }
};
exports.TabSwitch = TabSwitch;
